import { useRef, useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import playStore from '@/store/play'

const Audio = forwardRef((props, ref) => {
  const { playObj } = useSnapshot(playStore)
  const [isInit, setInit] = useState(true)
  const sliderFlag = useRef('click') // 滑块点击滑动的标志
  const originX = useRef(0) // 鼠标按下时候的X坐标
  const processWidth = useRef(0) // 进度条的宽度（滑块儿非滑动的时候）
  const sliderLeft = useRef(0) // 滑块儿的left（滑块儿非滑动的时候）
  const voiceLength = useRef(0) // 音频总时长
  const timer = useRef() // 定时器

  const wrapRef = useRef() // 播放条
  const sliderRef = useRef() // 滑块
  const processRef = useRef() // 进度条
  const audioRef = useRef() // audio

  // 初始化slider
  useEffect(() => {
    sliderRef.current.addEventListener('mousedown', e => {
      // sliderFlag.current = true
      // originX.current = e.clientX
      document.onmousemove = e => mouseMove(e)
      document.onmouseup = e => mouseUp(e)
    })
    // mouseDown(sliderRef.current)
  }, [])
  useEffect(() => {
    if (timer.current) clearInterval(timer.current)
    getVoiceTime()
    setVoiceTime(0)
    if (!playObj.url) return
    // 初始化的时候不自动播放
    if (isInit) return
    play()
    setInit(false) // 设置非初始化
  }, [playObj.id])

  // 按下slider
  const mouseDown = e => {
    // console.log(e)
    // e.stopPropagation()
    // e.preventDefault()
    // console.log("按下")
    // flag.current = true
    // e.nativeEvent.stopPropagation()
    // e.stopPropagation()
    // e.nativeEvent.stopImmediatePropagation()
    // console.log(processRef.current.clientWidth)
    originX.current = e.clientX
    // console.log(sliderRef.current.style.left)
    // console.log(processRef.current.style.width)
  }
  // 按拖动slider
  const mouseMove = e => {
    // console.log(e)
    e.stopPropagation()
    // console.log(e.clientX)
    sliderFlag.current = 'move'
    let l = e.clientX - originX.current
    // console.log(l)
    // console.log(processWidth.current)
    // console.log(wrapRef.current.clientWidth)
    if (l >= wrapRef.current.clientWidth - processWidth.current) {
      l = wrapRef.current.clientWidth - processWidth.current
    } else if (l <= -processWidth.current) {
      l = -processWidth.current
    }
    console.log(sliderLeft.current)
    sliderRef.current.style.left = sliderLeft.current - 7 + l + 'px'
    processRef.current.style.width = processWidth.current - 7 + l + 'px'
    // console.log("总时长", wrapRef.current.clientWidth)
    // console.log("进度条", processRef.current.clientWidth)
  }
  // 抬起slider
  const mouseUp = e => {
    // console.log(e)
    e.stopPropagation()
    // e.nativeEvent.stopImmediatePropagation()
    // console.log("抬起")
    sliderLeft.current = sliderRef.current.offsetLeft
    processWidth.current = processRef.current.clientWidth
    document.onmousemove = document.onmouseup = '' // 清除事件
    // console.log(sliderLeft.current)
    // console.log(processWidth.current)
    let l = processWidth.current / wrapRef.current.clientWidth // 播放的百分比
    // console.log(l)
    setVoiceTime(l * voiceLength.current)
    props.setCurTimer(Math.round(l * voiceLength.current))
  }
  // 点击播放条
  const wrapClick = e => {
    e.nativeEvent.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    // console.log(e)
    // if (flag.current) return
    // flag.current = true
    if (sliderFlag.current === 'click') {
      let x = e.nativeEvent.offsetX
      // console.log(x)
      sliderRef.current.style.left = x - 7 + 'px'
      processRef.current.style.width = x + 'px'
      sliderLeft.current = sliderRef.current.offsetLeft
      processWidth.current = processRef.current.clientWidth
      let l = x / wrapRef.current.clientWidth // 播放的百分比
      setVoiceTime(l * voiceLength.current)
      props.setCurTimer(Math.round(l * voiceLength.current))
    }
    sliderFlag.current = 'click'
  }
  // 播放
  const play = () => {
    if (!playObj.url) return
    audioRef.current.play()
    props.audioStatus('play')
    timer.current = setInterval(() => {
      playProcess(audioRef.current.currentTime)
    }, 1000)
    // audioRef.current.addEventListener("play", () => {
    //   console.log("正在播放")
    // })
    // 此方法放到外面会一直刷新执行，为什么呢？？？
    function listener() {
      sliderRef.current.style.left = 0 + 'px'
      processRef.current.style.width = 0 + 'px'
      clearInterval(timer.current)
      props.audioStatus('pause', true)
      props.nextMusic()
      audioRef.current.removeEventListener('ended', listener)
    }
    audioRef.current.addEventListener('ended', listener)
  }
  // 暂停
  const pause = () => {
    if (!playObj.url) return
    audioRef.current.pause()
    props.audioStatus('play')
    // audioRef.current.addEventListener("pause", () => {
    //   console.log("暂停播放")
    // })
  }
  // 取消auido的所有监听
  const cancelListener = () => {
    clearInterval(timer.current)
    audioRef.current.removeEventListener('play', () => {
      console.log('取消监听播放')
    })
    audioRef.current.removeEventListener('ended', () => {
      console.log('取消监听播放完成')
    })
    audioRef.current.removeEventListener('pause', () => {
      console.log('取消监听暂停播放')
    })
  }
  // 音量变化回调
  const volumeChange = val => {
    audioRef.current.volume = val
  }
  // 查看音频总时长
  const getVoiceTime = () => {
    voiceLength.current = parseInt(playObj.dt / 1000)
    // console.log(voiceLength.current)
  }
  // 设置音频播放进度
  const setVoiceTime = val => {
    audioRef.current.currentTime = Math.round(val)
  }
  // 进度条前进
  const playProcess = val => {
    // console.log(val / voiceLength.current)
    props.setCurTimer(val)
    let a = (val / voiceLength.current) * wrapRef.current.clientWidth
    sliderRef.current.style.left = a - 7 + 'px' // -7使用因为slider宽度为15,
    processRef.current.style.width = a + 'px'
  }
  // 歌曲切换回调
  const musicSwitch = () => {
    // props.setCurTimer(0)
    sliderRef.current.style.left = 0 + 'px'
    processRef.current.style.width = 0 + 'px'
    setTimeout(() => {
      play()
    }, 1500)
  }

  // 导出父组件可调用的方法
  useImperativeHandle(ref, () => ({
    play,
    pause,
    volumeChange,
    cancelListener,
    musicSwitch
  }))

  return (
    <div className="audioBox">
      <div className="wrap" ref={wrapRef} onClick={e => wrapClick(e)}>
        <div ref={sliderRef} className="slider" onMouseDown={e => mouseDown(e)}></div>
        <div className="process" ref={processRef}></div>
      </div>
      <audio ref={audioRef} className="audio" src={playObj.url} controls></audio>
    </div>
  )
})
export default Audio
